import { Component, h, createRef } from 'preact';
import cx from 'classnames';
import moment from 'moment';
import accounting from 'accounting';
import $ from 'jquery';
import { Dimension, InquiryGridCardDragData } from 'types/ui';
import { Inquiry } from 'types/inquiries';
import { InquiryIdleLabel } from './inquiry-idle-label.component';
import * as InquiriesActions from '../../../reducers/inquiries/inquiries.actions';

import { InquiryClientInfo } from '../shared/inquiry-client-info.component';
import { InquiryDateIndicator } from '../shared/inquiry-date-indicator';
import { InquiryCompactClientInfo } from '../shared/inquiry-compact-client-info.component';
import { InquiryCollectionAmountDisplay } from './inquiry-collection-amount-display.component';
import { InquiryCommissionAmountDisplay } from './inquiry-commission-amount-display.component';
import { InquiryInvoiceNumberDisplay } from './inquiry-invoice-number-display.component';
import { get } from 'lodash-es';
import { hopplerApi } from '../../../../../constants';
import Axios, { AxiosRequestConfig } from 'axios';
import e from 'express';
import getStore from '../../../store';
import { InquiryStage } from '../../../../../types/inquiries/inquiry-stage'

interface InquiryGridCardProps {
  inquiry: Inquiry;
  count?: number;
  stageSlug?: any;
  alwaysRender?: boolean;
  stageFromParams?: any;
  // CCP
  // All of these props need to be optional, because we need to show an
  // InquiryGridCard for the drag overlay
  onShowCommentsModal?: (inquiry: Inquiry) => void;
  onShowScheduleViewingModal?: (inquiry: Inquiry) => void;
  onShowSetFirstCallModal?: (inquiry: Inquiry) => void;
  onCreateVl?: (inquiry: Inquiry) => void;
  onCreateLoi?: (inquiry: Inquiry) => void;
  onUploadOfferSent?: (inquiry: Inquiry) => void;
  onUploadOfferAccepted?: (inquiry: Inquiry) => void;
  onCreateContractClick?: (inquiry: Inquiry) => void;
  onUploadContractClick?: (inquiry: Inquiry) => void;

  onEditInvoiceNumberClick?: (inquiry: Inquiry) => void;
  onEditCollectionAmountClick?: (inquiry: Inquiry) => void;
  onEditCommissionAmountClick?: (inquiry: Inquiry) => void;
  onCollectedClick?: (inquiry: Inquiry) => void;

  onCardDragStart?: (dragData: InquiryGridCardDragData) => void;
  onCardClicked?: (inquiry: Inquiry) => void;
  onCardDragMove?: (dragData: InquiryGridCardDragData) => void;
  onCardDragEnd?: () => void;
}

interface InquiryGridCardState {
  dragging?: boolean;
  cardOffset?: Dimension;
  cardWidth?: number;
  onScreen?: boolean;

  selectedReason?: string;
  details?: string;
  sendReasonStatus?: string;

  returnLeadSelectedReason?: Array<string>;
  returnLeadDetails?: string;
  returnLeadReasonStatus?: string;
  
  currentStage?: string;
}

// Long-press-for-drag conditions!
const LONG_PRESS_MOVEMENT_TOLERANCE = 16;
const LONG_PRESS_DURATION = 400;
const store = getStore();
// store.dispatch(InquiriesActions.loadStage('made-1st-call'));

export class InquiryGridCard extends Component<InquiryGridCardProps, InquiryGridCardState> {
  timeout: NodeJS.Timeout;
  touchStartEvent: TouchEvent;
  cardRef = createRef();
  dragElementRef = createRef<HTMLDivElement>();
  dummyCardRef = createRef<HTMLDivElement>();

  /**
   *
   */
  constructor() {
    super();
    
    this.state = {
      details: '',
      selectedReason: '',

      returnLeadSelectedReason: [],
      returnLeadDetails: '',
    }
  }

  // [IT-1654] Rendering issues observed with conditional rendering -- disable for now
  // dummyObserver: IntersectionObserver;
  // fullObserver: IntersectionObserver;

  componentDidMount() {

    if (window.location.pathname.includes('deals-lost')) {
      this.setState({ currentStage: 'deals-lost' })
    }

    // console.log({ state })

    // this.dummyObserver = new IntersectionObserver(
    //   (e) => this.onScreenEnter(e),
    //   {
    //     root: document.body,
    //     rootMargin: '32px'
    //   }
    // );
    // this.fullObserver = new IntersectionObserver(
    //   (a) => 420,
    //   {
    //     root: document.body,
    //     rootMargin: '64px'
    //   }
    // );

    // if (!this.props.alwaysRender) {
    //   this.dummyObserver.observe(this.dummyCardRef.current);
    // }
  }

  // onScreenEnter(entries: IntersectionObserverEntry[]) {
  //   entries.forEach(entry => {
  //     if (entry.target === this.dummyCardRef.current && entry.isIntersecting) {
  //       this.setState({ onScreen: true });
  //       this.dummyObserver.unobserve(this.dummyCardRef.current);
  //     }
  //   });
  // }

  //////////////////////////////////////////////////////////////////////////////
  // EVENT HANDLERS
  //////////////////////////////////////////////////////////////////////////////

  onCardClicked(event: MouseEvent, inquiry: Inquiry) {
    /*
      This is *unbelievably* hacky.
      This fixes a bug where the Bootstrap dropdown data-toggle="dropdown"
      utility does not stop the propagation of the mouse click, causing the
      inquiry details card callbacks to fire as well.

      The proper fix is to _not_ use the Bootstrap dropdown system as-is and
      switch to something that works within the Preact system.

      For now, let's just ignore anchors, <i> (FontAwesome icons, most likely),
      and buttons.
    */

    const ignoreList = ['a', 'i', 'button', 'input', 'label', 'textarea'];
    const target = event.target as HTMLElement;

    if (!ignoreList.includes(target.nodeName.toLowerCase())) {
      console.log({ nodeName: target.nodeName })
      // Clicked element was not an anchor or button -- we can continue
      if (this.props.onCardClicked) {
        this.props.onCardClicked(inquiry);
      }
    } else {
      return;
    }
  }

  /**
   * This is a workaround for an issue where on Chrome, the first drag event has
   * coords that are a little bit off from the actual cursor location, causing a
   * visual "flicker" of the overlay card in the wrong place.
   * 
   * As the onDragStart and the second onDrag event don't exhibit this issue, we
   * can simply ignore the first onDrag event. This stops the weird flickering.
   */
  _firstCursorMoveSkipped = false;

  onCardDragStart(event: TouchEvent | MouseEvent) {
    let pointerCoords: Dimension = {};
    if (event instanceof TouchEvent) {
      const touch = event.touches[0];
      pointerCoords.x = touch.clientX;
      pointerCoords.y = touch.clientY;
    } else {
      pointerCoords.x = event.clientX;
      pointerCoords.y = event.clientY;
    }

    this.timeout = null;

    const card = this.cardRef.current as HTMLDivElement;
    const boundingRect = card.getBoundingClientRect();
    const initialTouch: Dimension = {
      x: pointerCoords.x - boundingRect.left,
      y: pointerCoords.y - boundingRect.top
    }

    this.setState({
      dragging: true,
      cardOffset: initialTouch,
      cardWidth: boundingRect.width
    });

    if (this.props.onCardDragStart) {
      this.props.onCardDragStart({
        cursor: pointerCoords,
        cardTouchOffset: initialTouch,
        cardWidth: boundingRect.width,
        inquiry: this.props.inquiry
      });
    }
  }

  onCardDragEnd() {
    this.setState({ dragging: false });
    if (this.state.dragging && this.props.onCardDragEnd) {
      this.props.onCardDragEnd();
    }
  }

  onTouchStart(event: TouchEvent) {
    // console.log('onTouchStart');
    this.timeout = setTimeout(() => this.onCardDragStart(event), LONG_PRESS_DURATION);
    this.touchStartEvent = event;
  }

  onTouchMove(event: TouchEvent) {
    const touch = event.touches[0];
    const initialTouch = this.touchStartEvent.touches[0];

    if (!this.state.dragging && this.timeout) {
      // If we're waiting for the drag condition
      const exceededX = Math.abs(touch.clientX - initialTouch.clientX) > LONG_PRESS_MOVEMENT_TOLERANCE;
      const exceededY = Math.abs(touch.clientY - initialTouch.clientY) > LONG_PRESS_MOVEMENT_TOLERANCE;
      if (exceededX || exceededY) {
        clearTimeout(this.timeout);
        this.timeout = null;
        console.log('Drag trigger cancelled!');
      }
    } else if (this.state.dragging && this.props.onCardDragMove) {
      event.preventDefault();
      this.props.onCardDragMove({
        cursor: { x: touch.clientX, y: touch.clientY },
        cardTouchOffset: this.state.cardOffset,
        cardWidth: this.state.cardWidth,
        inquiry: this.props.inquiry
      });
    }
  }

  onTouchEnd(event: TouchEvent) {
    // console.log('onTouchEnd');

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (this.state.dragging && this.props.onCardDragEnd) {
      this.props.onCardDragEnd();
    }

    this.setState({ dragging: false });
  }

  onDragStart(evt: DragEvent) {
    // console.log('Drag start', evt);
    evt.dataTransfer.setDragImage(this.dragElementRef.current, 0, 0);
    evt.dataTransfer.dropEffect = 'move';
    evt.dataTransfer.setData('text/plain', this.props.inquiry.inquiryCode);
    this.onCardDragStart(evt);
  }

  onDrag(evt: DragEvent) {
    // console.log('Drag', evt);
    if (this._firstCursorMoveSkipped) {
      this.props.onCardDragMove({
        cursor: { x: evt.clientX, y: evt.clientY },
        cardTouchOffset: this.state.cardOffset,
        cardWidth: this.state.cardWidth,
        inquiry: this.props.inquiry
      });
    } else {
      this._firstCursorMoveSkipped = true;
    }
  }

  onDragEnd(evt: DragEvent) {
    this.props.onCardDragEnd();
    this.setState({ dragging: false });
    this._firstCursorMoveSkipped = false;
  }

  onRestoreInquiryClicked() {
    const cardID: string = `#card-${this.props.inquiry.inquiryCode}`;
    const path: string = `${hopplerApi.host}/kumita/inquiry/${this.props.inquiry.inquiryCode}/action/lost/restore`
    const config: AxiosRequestConfig = {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    Axios
      .post(path, {}, config)
      .then(() => {
        $(cardID).remove();
      })
      .catch((err: any) => {
        console.log({ err })
      })
  }

  onCompletedFirstViewing() {
    const menuItemID: string = `#1st-viewing-completed-${this.props.inquiry.inquiryCode}`;
    const path: string = `${hopplerApi.host}/kumita/inquiry/${this.props.inquiry.inquiryCode}/action/first-viewing-date`
    const config: AxiosRequestConfig = {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    Axios
      .post(path, {}, config)
      .then(() => {
        $(menuItemID).prop('disabled', true);;
      })
      .catch((err: any) => {
        console.log({ err })
      })
  }

  //////////////////////////////////////////////////////////////////////////////
  // CONDITIONAL ELEMENTS
  //////////////////////////////////////////////////////////////////////////////
  getActionsElement(props: InquiryGridCardProps, state: InquiryGridCardState) {
    if (props.stageSlug !== 'search') {
      let disableFirstViewingCompleted : boolean = true;
      if (props.inquiry.ccp.ccp04 === undefined && props.stageSlug === "viewings-scheduled") {
        disableFirstViewingCompleted = false;
      }
      return (
        <div className="hi-inqcard__cell hi-inqcard__actions-group">
          {/* Desktop elements */}
          
            <button 
              type="button"
              className="hi-inqcard__action-link btn btn-link"
              data-toggle="dropdown"
              >
              Take action <i className="fas fa-angle-down"></i>
            </button>
          
          {/*
            Due to the amount of code behind each action, this was a separate
            component in Kumita 1. Consider doing that here as well if necessary.
          */}

          { this.state.currentStage == 'deals-lost' && (
            <div className="dropdown-menu hi-inqcard__dropdown-menu">
              <button
                disabled
                className="dropdown-item btn btn-link">Assign to PB
              </button>

              {/* remove class: 'd-none' if API is functioning */}
              <button
                onClick={() => this.onRestoreInquiryClicked()}
                className="dropdown-item btn btn-link">Restore Inquiry
              </button>
            </div>
          )}

          
          { this.state.currentStage !== 'deals-lost' && (
            <div className="dropdown-menu hi-inqcard__dropdown-menu">
              <button
                disabled={ props.stageSlug == "made-1st-call" }
                onClick={ () => props.onShowSetFirstCallModal(props.inquiry) }
                className="dropdown-item btn btn-link">Set 1st call date
              </button>
                
              <button className="btn btn-link dropdown-item" href="#"
                onClick={ (e) => props.onCreateVl(props.inquiry)}>
                Create VL
              </button>

              <button
                disabled={ props.stageSlug == "viewings-scheduled"}
                onClick={ () => props.onShowScheduleViewingModal(props.inquiry) }
                className="dropdown-item btn btn-link">Schedule viewing
              </button>

              <button
                id={ "1st-viewing-completed-" + props.inquiry.inquiryCode }
                disabled={ disableFirstViewingCompleted }
                onClick={ () => this.onCompletedFirstViewing() }
                className="dropdown-item btn btn-link">Completed 1st Viewing
              </button>

              <button
                onClick={ () => props.onCreateLoi(props.inquiry) }
                className="dropdown-item btn btn-link">Create LOI
              </button>

              <button
                onClick={ () => props.onUploadOfferSent(props.inquiry) }
                className="dropdown-item btn btn-link">Mark Offer as sent
              </button>

              <button
                onClick={ () => props.onUploadOfferAccepted(props.inquiry) }
                className="dropdown-item btn btn-link">Upload Offer accepted
              </button>

              <button
                onClick={ () => props.onCreateContractClick(props.inquiry) }
                className="dropdown-item btn btn-link">Create Contract
              </button>
              
              <button
                onClick={ () => props.onUploadContractClick(props.inquiry) }
                className="dropdown-item btn btn-link">Upload Contract
              </button>

              <div className="dropdown-divider"></div>

              <button
                type="button"
                data-toggle="modal" 
                data-target={ "#tag-as-lost-" + props.inquiry.inquiryCode }
                className="dropdown-item btn btn-link">Tag as Lost
              </button>

              <button
                type="button"
                data-toggle="modal" 
                data-target={ "#return-lead-" + props.inquiry.inquiryCode }
                className="dropdown-item btn btn-link">Return Lead
              </button>

              {/* <a className="dropdown-item disabled" href="#" disabled>Tag as Lost</a> */}
              {/* <a className="dropdown-item disabled" href="#" disabled>Return Lead</a> */}
            </div>
          )}



          <span className="hi-inqcard__action-label">
            (or drag to the next stage)
          </span>

          {/* Mobile elements */}
          <a href='#' className="hi-inqcard__action-icon hi-inqcard__action-icon-dropdown" data-toggle="dropdown">
            <i className="far fa-caret-square-down" />
          </a>
          <a href='#' className="hi-inqcard__action-icon">
            <i className="fas fa-arrows-alt" />
          </a>
        </div>
      );
    }
  }

  getDetailsGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    const inquiry = props.inquiry;

    return (
      <div className="hi-inqcard__cell hi-inqcard__details-group">
        <div className="hi-inqcard__detail-row">
          <i className="far fa-fw fa-building"></i>
          <div className="hi-inqcard__detail-item">{ this.getInquiryDivCatCode(inquiry) }</div>
          <div className="hi-inqcard__detail-item">1BR</div>
          <div className="hi-inqcard__detail-item">{ inquiry.type }</div>
        </div>
        <div className="hi-inqcard__detail-row">
          <i className="fas fa-fw fa-tag"></i>
          { this.getFurnishingView(inquiry) }
          <div className="hi-inqcard__detail-item">{ this.getPriceString(inquiry) }</div>
        </div>
        <div className="hi-inqcard__detail-row">
          <i className="fas fa-fw fa-map-pin"></i>
          <span className="hi-inqcard__location-detail-item">{ inquiry.location }</span>
        </div>
      </div>
    );
  }

  getInquiryDateGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    if (props.stageSlug !== 'for-collection') {
      return (
        <div className="hi-inqcard__cell hi-inqcard__date">
          { moment(props.inquiry.dateCreated).format('MM/DD/YY') }
          <InquiryIdleLabel inquiry={ props.inquiry } forTableMode={ true } />
        </div>
      );
    }
  }

  getClientInfoGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    if (props.stageSlug === 'for-collection') {
      return (
        <div className="hi-inqcard__cell hi-inqcard__compact-info-group">
          <InquiryCompactClientInfo inquiry={ props.inquiry } />
        </div>
      );
    } else {
      return (
        <InquiryClientInfo 
          centered={ false }
          inquiry={ props.inquiry }
          forceDefaultStyling={ props.stageSlug !== 'for-collection' }
        />
      );
    }
  }

  getCollectionAmountGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    if (props.stageSlug === 'for-collection') {
      return (
        <div className="hi-inqcard__cell hi-inqcard__collection-amount-group">
          <InquiryCollectionAmountDisplay inquiry={ props.inquiry }
            onEditClick={ props.onEditCollectionAmountClick } />
        </div>
      );
    }
  }

  getHopplerCommissionGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    if (props.stageSlug === 'for-collection') {
      return (
        <div className="hi-inqcard__cell hi-inqcard__collection-amount-group">
          <InquiryCommissionAmountDisplay
            amount={ props.inquiry.commissionHoppler }
            inquiry={ props.inquiry }
            onEditClick={ props.onEditCommissionAmountClick }
          />
        </div>
        )
    }
  }

  getBrokerCommissionGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    if (props.stageSlug === 'for-collection') {
      return (
        <div className="hi-inqcard__cell hi-inqcard__collection-amount-group">
          <InquiryCommissionAmountDisplay
            amount={ props.inquiry.commissionCoBroker }
            inquiry={ props.inquiry }
            onEditClick={ props.onEditCommissionAmountClick }
          />
        </div>
      )
    }
  }

  getInvoiceNumberGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    if (props.stageSlug === 'for-collection') {
      return (
        <div className="hi-inqcard__cell hi-inqcard__invoice-number-group">
          <InquiryInvoiceNumberDisplay inquiry={ props.inquiry }
            onEditClick={ props.onEditInvoiceNumberClick } />
        </div>
      );
    }
  }

  getCollectedButtonGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    if (props.stageSlug === 'for-collection') {
      let buttonText: string = "Collect"
      if (props.inquiry.collected) {
        buttonText = "Collected"
      }
      return (
        <div className="hi-inqcard__cell hi-inqcard__collected-btn-group">
          <button className="btn btn-outline-dark hi-inqcard__collected-btn"
            disabled={ !!props.inquiry.collected }
            onClick={ () => props.onCollectedClick(props.inquiry) }>
            { buttonText }
          </button>
        </div>
      );
    }
  }

  getContactInfoGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    const inquiry = props.inquiry;
    return (
      <div className="hi-inqcard__cell hi-inqcard__contact-group">
        <span className="hi-inqcard__contact-detail">{ inquiry.client.mobile }</span>
        <span className="hi-inqcard__contact-detail">{ inquiry.client.email }</span>
      </div>
    )
  }

  getMoveInGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    return (
      <div className="hi-inqcard__cell hi-inqcard__movein-group">
        <InquiryDateIndicator
          highlighted={ false } 
          date={ props.inquiry.dateMoveIn } />
        <label className="hi-inqcard__movein-label">Move-in</label>
      </div>
    )
  }

  getAttachmentsGroup(props: InquiryGridCardProps, state: InquiryGridCardState) {
    const inquiry = props.inquiry;

    return (
      <div className="hi-inqcard__cell hi-inqcard__attachments-group">
        <a 
          onClick={ () => props.onShowCommentsModal(inquiry) }
          href='#' 
          className="hi-inqcard__attachment-button">
          <i className="fas fa-comment-alt"></i> { inquiry.attachments.comments }
        </a>
        <button className="btn btn-link hi-inqcard__attachment-button" onClick={ e => props.onCardClicked(this.props.inquiry) }>
          <i className="fas fa-paperclip"></i>
        </button>
      </div>
    )
  }

  getStageNameElement(props: InquiryGridCardProps, state: InquiryGridCardState) {
    if (props.stageSlug === 'search') {
      const stageKebab = props.inquiry.stage.toLowerCase().replace(/ /g, '-');
      return (
        <div className="hi-inqcard__cell hi-inqcard__stage-name-group">
          <span className={ `hi-inqcard__stage-name-pill hi-inqcard__stage-name-pill--${stageKebab}` }>
            { props.inquiry.stage }
          </span>
        </div>
      )
    }
  }

  //////////////////////////////////////////////////////////////////////////////
  // DATA FORMATTING
  //////////////////////////////////////////////////////////////////////////////

  getInquiryDivCatCode(inquiry: Inquiry) {
    const divCode = inquiry.division == 'Residential' ? 'R' : 'C';
    const catCode = inquiry.category == 'Rent' ? 'R' : 'S';

    return `${divCode}${catCode}`;
  }

  getFurnishingView(inquiry: Inquiry) {
    let furnishing: string;

    if (inquiry.ftf.furnishingUF) {
      furnishing = 'UF';
    } else if (inquiry.ftf.furnishingSF) {
      furnishing = 'SF';
    } else if (inquiry.ftf.furnishingFF) {
      furnishing = 'FF';
    } else {
      return null;
    }

    return (
      <div className="hi-inqcard__detail-item">
        { furnishing }
      </div>
    )
  }

  getPriceString(inquiry: Inquiry) {
    return accounting.formatMoney(inquiry.ftf.budget.max, 'PHP ', 0);
  }

  handleResetState() {
    const t = this;
    t.setState({
      selectedReason: '',
      details: '',
      sendReasonStatus: '',

      returnLeadSelectedReason: [],
      returnLeadReasonStatus: '',
      returnLeadDetails: ''
    });

    const returnLeadModal: any = $('#return-lead-' + t.props.inquiry.inquiryCode);
    const tagAsLostModal: any = $('#tag-as-lost-' + t.props.inquiry.inquiryCode);

    returnLeadModal.modal('hide');
    tagAsLostModal.modal('hide');

    store.dispatch(InquiriesActions.loadStage(this.props.stageFromParams));
  }

  /**
   * Renders only the inquiry card's outermost div, as an optimization for
   * use with offscreen cards.
   */
  renderDummyCard() {
    return (
      <div className="hi-inqcard" ref={ this.dummyCardRef } />
    );
  }

  handleReturnLeadReasonCheck(reason: string) {
    const index = this.state.returnLeadSelectedReason.findIndex((r: any) => r == reason);

    if (index !== -1) {
      const newList = this.state.returnLeadSelectedReason.filter((r: any) => r !== reason);
      this.setState({ returnLeadSelectedReason: newList });
    } else {
      this.setState({ 
        returnLeadSelectedReason: [...this.state.returnLeadSelectedReason, reason] 
      });
    }

  }

  handleReturnLeadDetailsChanged(details: string) {
    this.setState({ returnLeadDetails: details })
  }

  handleReasonsChecked(reason: string) {
    this.setState({ selectedReason: reason });
  }

  handleDetailsChanged(details: string) {
    this.setState({ details });
  }

  handleReturnLeadSave() {
    this.setState({ returnLeadReasonStatus: 'loading' });
    const path: string = `${hopplerApi.host}/kumita/inquiry/${this.props.inquiry.inquiryCode}/action/return`
    const payload = {
      reason: this.state.returnLeadSelectedReason.join(', '),
      details: this.state.returnLeadDetails
    };
    const config: AxiosRequestConfig = {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    Axios
      .post(path, payload, config)
      .then(() => {
        this.setState({ returnLeadReasonStatus: 'success'});
      })
      .catch((err: any) => {
        console.log({ err })
        this.setState({ returnLeadReasonStatus: 'failed '});
        alert(err.response.data.msg)
      })
  }

  handleSaveReason() {
    this.setState({ sendReasonStatus: 'loading' });
    const path: string = `${hopplerApi.host}/kumita/inquiry/${this.props.inquiry.inquiryCode}/action/lost`
    const payload = {
      reason: this.state.selectedReason,
      details: this.state.details
    }
    const config: AxiosRequestConfig = {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }

    Axios
      .post(path, payload, config)
      .then(() => {
        this.setState({ sendReasonStatus: 'success'});
      })
      .catch((err: any) => {
        this.setState({ sendReasonStatus: 'failed '});
        alert(err.response.data.msg)
      })
  }

  renderFullCard(props: InquiryGridCardProps, state: InquiryGridCardState) {
    const { inquiry } = props;

    const reasons = [
      { key: 1, label: 'Unable to find listings' },
      { key: 2, label: 'Unrealistic requirements - budget' },
      { key: 3, label: 'Unrealistic requirements - other' },
      { key: 4, label: 'No first response from client' },
      { key: 5, label: 'Client stopped responding' },
      { key: 6, label: 'Lost to another broker' },
      { key: 7, label: 'Other' },
    ];

    return (
      <div ref={ this.cardRef }
        id={ "card-" + props.inquiry.inquiryCode}
        onClick={ (event) => this.onCardClicked(event, inquiry) } 
        className={ cx("hi-inqcard", {
          'hi-inqcard--dragging': state.dragging,
          'hi-inqcard--search': props.stageSlug === 'search',
          'hi-inqcard--for-collection': props.stageSlug === 'for-collection'
        }) }>

        <div 
          className="modal fade reasons-modal"
          id={ "return-lead-" + props.inquiry.inquiryCode}
          tabIndex={-1}
          role="dialog"
          aria-labelledby="return-lead-modal"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              style={{ minHeight: '480px' }} 
              className="modal-content">
              <div className="position-relative d-flex align-items-center justify-content-center py-3 w-100 border-bottom">
                <p className="hi-vlmodal__title-label mb-0">Return Lead</p>
                <button
                  style={{ right: '0', top: '15px' }}
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => this.handleResetState()}
                  className="position-absolute btn btn-link hi-vlmodal__title-close">
                  <i className="fas fa-times" /> Close
                </button>
              </div>

              <div className="modal-body py-4 px-5">
                { this.state.returnLeadReasonStatus == 'success' && (
                  <div
                    style={{ height: '360px' }} 
                    className="d-flex flex-column py-5 justify-content-center align-items-center">
                    <p className="h4">Successfully Returned Lead</p>
                    <p>Inquiry will be moved under Returned Leads</p>
                    <button
                      type="button"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.handleResetState()}
                      className="btn btn-secondary mt-5">
                      Go back to pipeline
                    </button>
                  </div>
                )}

                {this.state.returnLeadReasonStatus !== 'success' && (
                  <div>
                    <p className="font-weight-bold">Select Reason:</p>
                    { reasons.map((reason: any) => (
                      <div className="d-flex align-items-center mb-2 reason">
                        <input
                          onChange={() => this.handleReturnLeadReasonCheck(reason.label)} 
                          className="mr-2"
                          checked={this.state.returnLeadSelectedReason.includes(reason.label)}
                          id={`${reason.key}-return-lead-reason`} 
                          type="checkbox" />
                        <label
                          style={{fontSize: '15px'}}
                          for={`${reason.key}-return-lead-reason`} 
                          className="mb-0">{reason.label}</label>
                      </div>
                    )) }
                      
                    { this.state.returnLeadSelectedReason.includes('Other') && (
                      <textarea 
                        value={state.returnLeadDetails}
                        placeholder="Other reasons"
                        className="form-control"
                        onChange={(e: any) => this.handleReturnLeadDetailsChanged(e.target.value)}
                        name="" />
                    )}

                    <div className="d-flex align-items-center justify-content-center mt-5 pt-3">
                      <button
                        disabled={state.returnLeadSelectedReason.length == 0 || state.returnLeadReasonStatus == 'loading'}
                        onClick={() => this.handleReturnLeadSave()}
                        type="button" 
                        className="btn btn-secondary text-center w-25">
                        Save
                      </button>
                    </div>
                  </div>
                )}
                
              </div>
            </div>
          </div>
        </div>

        <div 
          className="modal fade reasons-modal"
          id={ "tag-as-lost-" + props.inquiry.inquiryCode }
          tabIndex={-1}
          role="dialog"
          aria-labelledby="tag-as-lost-modal"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              style={{ minHeight: '480px' }} 
              className="modal-content">
              <div className="position-relative d-flex align-items-center justify-content-center py-3 w-100 border-bottom">
                <p className="hi-vlmodal__title-label mb-0">Tag Inquiry as Lost</p>
                <button
                  style={{ right: '0', top: '15px' }}
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => this.handleResetState()}
                  className="position-absolute btn btn-link hi-vlmodal__title-close">
                  <i className="fas fa-times" /> Close
                </button>
              </div>

              <div className="modal-body py-4 px-5">
                { this.state.sendReasonStatus == 'success' && (
                  <div
                    style={{ height: '360px' }} 
                    className="d-flex flex-column py-5 justify-content-center align-items-center">
                    <p className="h4">Successfully Tagged as Lost</p>
                    <p>Inquiry will be moved under deals Lost</p>
                    <button
                      type="button"
                      data-dismiss="modal"
                      onClick={() => this.handleResetState()}
                      aria-label="Close"
                      className="btn btn-secondary mt-5">
                      Go back to pipeline
                    </button>
                  </div>
                )}

                {this.state.sendReasonStatus !== 'success' && (
                  <div>
                    <p className="font-weight-bold">Select Reason:</p>
                    { reasons.map((reason: any) => (
                      <div className="d-flex align-items-center mb-2 reason">
                        <input
                          onChange={() => this.handleReasonsChecked(reason.label)} 
                          className="mr-2"
                          checked={this.state.selectedReason == reason.label}
                          id={`${reason.key}-reason`} 
                          type="radio" />
                        <label
                          style={{fontSize: '15px'}}
                          for={`${reason.key}-reason`} 
                          className="mb-0">{reason.label}</label>
                      </div>
                    )) }
                      
                    { this.state.selectedReason == 'Other' && (
                      <textarea 
                        value={state.details}
                        placeholder="Other reasons"
                        className="form-control"
                        onChange={(e: any) => this.handleDetailsChanged(e.target.value)}
                        name="" />
                    )}

                    <div className="d-flex align-items-center justify-content-center mt-5 pt-3">
                      <button
                        disabled={state.selectedReason == '' || state.sendReasonStatus == 'loading'}
                        onClick={() => this.handleSaveReason()}
                        type="button" 
                        className="btn btn-secondary text-center w-25">
                        Save
                      </button>
                    </div>
                  </div>
                )}
                
              </div>
            </div>
          </div>
        </div>
          
        {/* 
          Drag and drop handlers temporarily removed:

          onTouchStart={ evt => this.onTouchStart(evt) }
          onTouchEnd={ evt => this.onTouchEnd(evt) }
          onTouchCancel={ evt => this.onTouchEnd(evt) }
          onTouchMove={ evt => this.onTouchMove(evt) }
          
          draggable={ true }
          onDragStart={ evt => this.onDragStart(evt) }
          onDrag={ evt => this.onDrag(evt) }
          onDragEnd={ evt => this.onDragEnd(evt) }
        */}

        {/*
          Desktop "Inquiry Date" section
          These two *SPLIT UP* on mobile, so they *MUST* be two separate elements.
        */}
        { this.getInquiryDateGroup(props, state) }
        <InquiryIdleLabel inquiry={ props.inquiry } forTableMode={ false } />

        { this.getClientInfoGroup(props, state) }

        { this.getCollectionAmountGroup(props, state) }
        { this.getHopplerCommissionGroup(props, state) }
        { this.getBrokerCommissionGroup(props, state) }
        { this.getInvoiceNumberGroup(props, state) }

        { this.getContactInfoGroup(props, state) }

        { this.getMoveInGroup(props, state) }

        { this.getDetailsGroup(props, state) }


        { this.getAttachmentsGroup(props, state) }

        { this.getActionsElement(props, state) }

        { this.getStageNameElement(props, state) }

        { this.getCollectedButtonGroup(props, state) }

        {/*
          We want our desktop drag visuals to match the mobile version, so we
          have to use this invisible div as our drag image, and show a card
          element "attached" to cursor movement.
        */}
        <div className="d-none" ref={ this.dragElementRef } />
      </div>
    );
  }

  render(props: InquiryGridCardProps, state: InquiryGridCardState) {

    // IT-1654 Found issues with conditional rendering -- disable for now.
    // if (state.onScreen || props.alwaysRender) {
    //   return this.renderFullCard(props, state);
    // } else {
    //   return this.renderDummyCard();
    // }
    return this.renderFullCard(props, state);
  }
}